import { TabbedItemPage } from './TabbedItemPage';

export const SuperannuationPage = () => <TabbedItemPage itemPath="/maintenance/superannuation" />;
